import reduceOrders from '../helpers/reduceOrders'
import { orderQuery } from 'utils/queries'

export default async ({ path, graphql, state }) => {
  const { limit, skip, statuses, assignedTo } = state.get('orderHistory')

  const result = await graphql.query(
    orderQuery({
      status: `[${statuses.join()}]`,
      skip,
      limit,
      withAssignedTo: assignedTo,
      withHistory: true
    })
  )

  const { orders } = result
  if (orders.count > 0) {
    return path.loaded({
      orders: reduceOrders(orders.orders),
      count: orders.count
    })
  } else {
    return path.noOrders()
  }
}



// WEBPACK FOOTER //
// ./src/modules/OrderHistory/actions/loadOrderHistory.js